import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Store } from 'store/storeTypes';
import {
  closeHolidaysModal,
  setHolidaysCalendarMonth,
  startHolidaysDrag,
  hoverHolidaysDrag,
  finalizeHolidaysDrag,
  updateHolidayName,
  updateHolidayRepeat,
  requestDeleteHoliday,
  cancelDeleteHoliday,
} from 'actions/holidaysActions';
import {
  saveHolidaysDraftRequest,
  confirmDeleteHolidayRequest,
} from 'actions/productionHoursApiActions';
import {
  selectHolidaysIsModalOpen,
  selectHolidaysDraft,
  selectHolidaysCalendarYear,
  selectHolidaysCalendarMonth,
  selectHolidaysDragAnchor,
  selectHolidaysDragHover,
  selectHolidaysPendingDeleteId,
  selectHolidaysActiveSites,
} from './holidaysSelectors';
import { canEditProductionHoursSelector } from 'selectors/uiSelectors';
import HolidaysModal from './components/HolidaysModal';

const mapStateToProps = (state: Store) => {
  const sites = selectHolidaysActiveSites(state);

  return {
    isOpen: selectHolidaysIsModalOpen(state),
    readOnly: !canEditProductionHoursSelector(state),
    sites,
    draft: selectHolidaysDraft(state),
    calendarYear: selectHolidaysCalendarYear(state),
    calendarMonth: selectHolidaysCalendarMonth(state),
    dragAnchor: selectHolidaysDragAnchor(state),
    dragHover: selectHolidaysDragHover(state),
    isLoading: state.productionHoursApi.isLoadingHolidays,
    isSaving:
      state.productionHoursApi.isSavingHoliday || state.productionHoursApi.isDeletingHoliday,
    pendingDeleteId: selectHolidaysPendingDeleteId(state),
    isDeletingHoliday: state.productionHoursApi.isDeletingHoliday,
    // Draft items present here are already saved on the server — used to tell them apart
    // from ones just added this session (different styling, different click/delete behavior).
    savedHolidayIds: sites.flatMap(site => (state.holidays.bySite[site] ?? []).map(b => b.id)),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onClose: closeHolidaysModal,
      onSave: saveHolidaysDraftRequest,
      onSetCalendarMonth: setHolidaysCalendarMonth,
      onStartDrag: startHolidaysDrag,
      onHoverDrag: hoverHolidaysDrag,
      onFinalizeDrag: finalizeHolidaysDrag,
      onUpdateName: updateHolidayName,
      onUpdateRepeat: updateHolidayRepeat,
      onRequestDelete: requestDeleteHoliday,
      onCancelDelete: cancelDeleteHoliday,
      onConfirmDelete: confirmDeleteHolidayRequest,
    },
    dispatch
  );

export type HolidaysModalProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(HolidaysModal);
